var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderlineNavItem = function SvgUnderlineNavItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 2,
    preserveAspectRatio: "none",
    viewBox: "0 0 38 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE41",
    d: "M0 .762S9.272.218 16.695.06C26.142-.14 38 .226 38 .226l-.552 1.016S30.636.807 17.07 1.208C6.16 1.53.671 2 .671 2z"
  })));
};
export default SvgUnderlineNavItem;